<template>
  <div>
    <div class="container-fluid bg-image-full" 
    id="hero-section"
    :style="{ backgroundImage: 'url(' + require('@/assets/site/img/hero-enjoy-x17.jpg') + ')' }">

      <div class="container">
        <img src="@/assets/site/img/enjoy-dark-back.png" alt="" class="img-fluid" id="main-logo">
        <div class="row">
          <div class="col-md-5 spacer d-flex align-items-center">
              <div>
                <h1 class="display-4 main-title">Bouwen aan de toekomst <strong>zonder zwerfafval</strong></h1>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-7 spacer d-flex align-items-center">
          <h2 class="big-text" v-reveal-words="{ offset: 0.4, duration: 0.5 }">
            <span class="color-primary">Project X17</span> is een volledig autonome robot die zwerfafval actief opspoort en opruimt. De robot wordt actief ontworpen voor de continue inzet op locaties met hoge afvaldruk, met als doel natuur, waterwegen en stedelijke leefomgeving te beschermen.
          </h2>
        </div>
      </div>
    </div>
    <div class="background-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3 spacer d-flex align-items-center mb-5">
            <div>
              <h2 class="color-primary">De vraag naar innovatie</h2>
              <p class="big-text" v-reveal-words="{ offset: 0.4, duration: 0.5 }">
                Zwerfafval bereikt natuurgebieden en waterwegen omdat opruimen vaak reactief en incidenteel gebeurt. Onderzoek en beleid tonen aan dat continue inzet en preventie aantoonbaar effectiever zijn dan losse opruimacties. Structurele monitoring en directe interventie verminderen ophoping, milieuschade en kosten op de lange termijn.
                Landelijke programma’s zoals de Landelijke Aanpak Zwerfafval van Rijkswaterstaat onderbouwen dat vroege onderschepping en permanente inzet cruciaal zijn om afvalstromen te beheersen. Ook internationaal onderzoek laat zien dat autonome en continue schoonmaaksystemen een oplossing bieden voor arbeidsdruk en schaalbaarheid.
                Project X17 bestaat om deze kloof te dichten: van achteraf opruimen naar voorkomen voordat afval schade aanricht.
              </p>
              <img class="img-fluid content-image" src="@/assets/site/img/x17-impression-alt3.jpg" alt="">
            </div>
          </div>
          <!-- <div class="col-md-6 bg-image-full spacer"
          :style="{ backgroundImage: 'url(' + require('@/assets/site/img/x17-impression-alt3.png') + ')' }"
          ></div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid bg-image-full" 
    :style="{ backgroundImage: 'url(' + require('@/assets/site/img/x17-impression-alt.jpg') + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-md-5 spacer d-flex align-items-center">
              <div>
                <h2 class="display-4 main-title">Virtuele barrières <strong>tegen zwerfafval</strong></h2>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 spacer d-flex align-items-center">
          <h2 class="big-text text-center" v-reveal-words="{ offset: 0.4, duration: 0.5 }">
            X17 gaat verder dan alleen opruimen. De robot kan dynamische virtuele barrières opzetten om te voorkomen dat afval kritieke natuurgebieden en waterwegen bereikt. Dit vormt een proactieve laag van preventie bovenop traditionele opruimmethoden.
          </h2>
        </div>
      </div>
    </div>

     <div class="background-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="info-card">
              <h2 class="color-primary">Inzet op piekbelasters en kritieke gebieden</h2>
              <p class="big-text">
                X17 is bedoeld voor gerichte inzet bij locaties met een hoge afvalproductie en kwetsbare gebieden, zoals:
              </p>
                <ul>
                  <li>fastfoodrestaurants;</li>
                  <li>parkeerplaatsen en recreatiegebieden;</li>
                  <li>stedelijke randen en fietsroutes;</li>
                  <li>aanvoerpunten richting rivieren en kanalen.</li>
              </ul>
              <p>
                Door continu autonoom te werken wordt afval vroegtijdig onderschept voordat het kan verspreiden.
              </p>
              
            </div>
          </div>
          <div class="col-md-6">
            <div class="info-card">
              <h2 class="color-primary">Autonoom, slim en schaalbaar</h2>
              <p class="big-text">
                X17 werkt volledig zelfstandig. Navigatie, detectie en inzameling verlopen zonder menselijke tussenkomst. Dit betekent:
              </p>
                <ul>
                  <li>werkdag en nacht inzet;</li>
                  <li>lage operationele kosten;</li>
                  <li>samenwerking tussen meerdere robots voor grote gebieden.</li>
              </ul>
              
            </div>
          </div>
        </div>
      </div>
    </div>

     <div class="container">
      
    </div>

    <div class="background-section">
      <div class="container">
        <div class="row">
        <div class="col-md-6 offset-md-3 spacer d-flex align-items-center">
          <h2 class="big-text text-center" v-reveal-words="{ offset: 0.4, duration: 0.5 }">
            Project X17 wordt ontwikkeld in het robotlab van Enjoycleaningup. Hier komt praktijkervaring uit opruimacties samen met geavanceerde robotica en AI-technologie. Het doel is een robuuste, toepasbare oplossing die bedrijven en overheden ondersteunt bij efficiënte afvalpreventie.
          </h2>
        </div>
      </div>
        <div class="row">
          <div class="col-md-6 offset-md-3 spacer d-flex align-items-center mb-5">
            <div>
              <h2 class="color-primary">Ontwikkeld in het Trashlab</h2>
              <p class="big-text" v-reveal-words="{ offset: 0.4, duration: 0.5 }">
                Project X17 wordt actief ontwikkeld in het robotlab van Enjoycleaningup. Hier komt praktijkervaring uit opruimacties samen met geavanceerde robotica en AI-technologie. Het doel is een robuuste, toepasbare oplossing die bedrijven en overheden ondersteunt bij efficiënte afvalpreventie.
              </p>
              <img class="img-fluid content-image" src="@/assets/site/img/snapshot-trashlab.jpg" alt="">
              <h2 class="color-primary mt-4">Wet- en regelgeving</h2>
              <p>
                Autonome inzet in de openbare ruimte is in Nederland nog niet wettelijk toegestaan. Er zijn wettelijke kaders nodig voor autonome systemen die zonder toezicht opereren in openbare omgevingen.
                Momenteel is autonoom inzet toegestaan op privéterrein. Tegelijkertijd wordt op landelijk niveau gewerkt aan regelgevingskaders om dit type technologie in de toekomst veilig en verantwoord toe te laten. Dit is een groeiend onderwerp binnen smart city-beleid en innovatieagenda’s van gemeenten en kennisinstellingen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

     <div class="container mt-5">
        <div class="row ">
          <div class="col-md-6 offset-md-3 spacer d-flex align-items-center mb-5">
            <div>
              <h2 class="color-primary">Samenwerking en sponsoring</h2>
              <p>
                Enjoycleaningup is op zoek naar samenwerkingspartners en sponsoren voor:
              </p>
              <ul>
                  <li>pilots en praktijklocaties;</li>
                  <li>doorontwikkeling van hardware en software;</li>
                  <li>opschaling richting brede inzet.</li>
              </ul>
              <p>
                Bedrijven en overheden kunnen hiermee direct bijdragen aan innovatieve oplossingen tegen zwerfafval.
              </p>
              <hr>
              <p class="mt-5">Updates over pilots, regelgeving en samenwerkingen verschijnen op Enjoycleaningup.com.</p>
              <p>
                - Team Enjoycleaningup
              </p>
              <a href="https://enjoycleaningup.com" target="_blank" class="btn btn-primary mt-3">Bezoek Enjoycleaningup.com</a>
            </div>
          </div>
        </div>
      </div>
      
</template>

<style scoped>
.spacer {
  min-height: max(600px, 60vh);
  height: auto;
}
.main-title {
  color: white;
  font-weight: 400;
  text-shadow: 0px 0px 50px #000000;
  line-height: 1;
}
.main-title strong {
  font-weight: 700;
}
#main-logo {
  margin-top: 50px;
  position: absolute;
  width: 80px;
}
p, ul{
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
}
.background-section {
  background-color: #000;
  padding-top: 60px;
  padding-bottom: 60px;
}
.info-card{
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;  
}

img.content-image{
  border-radius: 50px;
}
</style>